import React from 'react';
import { motion } from 'framer-motion';
const questions = ['What should you work on?', 'Which drills should you use?', 'How do you make the session different from last week?', 'How do you progress the athlete without jumping ahead too quickly?', 'How do you combine technique, footwork, defense, pads, bag work, conditioning and tactics into one session that makes sense?'];
const painPoints = ['Hours spent searching for drills and session ideas', 'Repeating the same exercises because they are easy to remember', 'Sessions that feel disconnected instead of progressive', 'Athletes doing drills without understanding the purpose', 'Difficulty adapting work for beginner, intermediate and advanced boxers', 'Too many corrections at once', 'Conditioning that starts to replace technical development', 'Last-minute sessions when your original plan no longer works', 'Uncertainty about what an athlete should work on next', 'Free time disappearing into planning'];
export function PainPoints() {
  return <section className="py-24 px-4 bg-section border-y border-line" data-id="element-158" data-mp="1yyu5r7f9jr9k">
      <div className="max-w-3xl mx-auto" data-id="element-159" data-mp="1u0iwaxsvrirv">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mb-14" data-id="element-160" data-mp="1tzhiwmoe6k6z">
          <p className="text-gold font-semibold tracking-widest uppercase text-xs mb-3 text-center" data-id="element-161" data-mp="1g11408gdlndr">
            The Sunday-night coaching problem
          </p>
          <h2 className="text-3xl md:text-4xl font-display font-bold mb-8 text-white text-center" data-id="element-162" data-mp="1b52kay5zstjo">
            Sound familiar?
          </h2>
          <div className="bg-card border border-line rounded-2xl p-6 md:p-8" data-id="element-163" data-mp="1k2cv6iewego2">
            <p className="text-lg text-white mb-4" data-id="element-164" data-mp="30h4p4zrozvzh">
              Sunday night. Athletes arriving tomorrow. And instead of switching off, you are still
              thinking about the next session.
            </p>
            <ul className="space-y-2 mb-6 border-l-2 border-gold/50 pl-4" data-id="element-165" data-mp="1t5y8ik5tod2h">
              {questions.map(question => <li key={question} className="text-mist" data-id="element-166" data-mp="1y2oo76dpt6nd">
                  {question}
                </li>)}
            </ul>
            <p className="text-lg text-mist" data-id="element-167" data-mp="274xxjsx8ytz6">
              <span className="text-gold font-semibold" data-id="element-168" data-mp="273v4pfgd6hgm">Not because you do not understand boxing.</span>{' '}
              You do. The problem is turning that knowledge into complete sessions over and over
              again — every week, every athlete, every group, every level.
            </p>
          </div>
        </motion.div>

        <h3 className="text-xl font-display font-bold text-white mb-6 text-center" data-id="element-169" data-mp="1jd8yzutu199s">
          The real cost of planning everything from scratch
        </h3>
        <ul className="grid sm:grid-cols-2 gap-3" data-id="element-170" data-mp="qpmxcs460epk">
          {painPoints.map((point, index) => <motion.li key={point} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.25,
          delay: index * 0.03,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-start gap-3 bg-card p-4 rounded-xl border border-line" data-id="element-171" data-mp="vopr3gep2yi8" data-mpi={index}>
              <span className="mt-2 w-1.5 h-1.5 rounded-full bg-steel shrink-0" aria-hidden="true" data-id="element-172" data-mp="a70e453mhpf9" />
              <span className="text-mist text-sm" data-id="element-173" data-mp="57w63hsfpxqi">{point}</span>
            </motion.li>)}
        </ul>
        <div className="text-center mt-12 pt-8 border-t border-line" data-id="element-174" data-mp="ge5iuubpz62">
          <p className="text-2xl font-display font-bold text-white" data-id="element-175" data-mp="3rmpa30yjli25">
            Your coaching knowledge is already there. What you need is a system that helps you
            organize and use it.
          </p>
          <p className="text-xl mt-4 text-gold font-semibold" data-id="element-176" data-mp="3imsfkiph1oz6">
            Plan an entire year of boxing sessions today.
          </p>
        </div>
      </div>
    </section>;
}